import React from 'react';
import { Wrench, Phone } from 'lucide-react';
import Navbar from './Navbar';

export default function MaintenanceScreen({ onLoginClick }: { onLoginClick?: () => void }) {
  return (
    <div className="bg-white min-h-screen flex flex-col relative overflow-hidden">
      <Navbar onLoginClick={onLoginClick || (() => {})} hideNav />
      
      <main className="flex-1 flex items-center justify-center p-6 relative z-10 mt-10 md:mt-16">
        <div className="w-full max-w-xl text-center flex flex-col items-center">
          
          <div className="w-20 h-20 mb-10 flex items-center justify-center rounded-2xl bg-amber-50">
            <Wrench className="w-8 h-8 text-amber-500" />
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-slate-800 tracking-tight mb-4" style={{ fontFamily: "'Sharp Grotesk SmBold 13', 'Inter', sans-serif" }}>
            Under Maintenance
          </h1>
          
          <p className="text-slate-500 text-lg leading-relaxed mb-12 max-w-md">
            We're currently performing scheduled updates. Our website is under maintenance. Thank you for your patience!
          </p>

          <a 
            href="https://wa.me/94742300407"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-3 bg-white border border-slate-200 hover:border-green-400 hover:shadow-md transition-all duration-300 px-6 py-3.5 rounded-xl"
          >
            <Phone className="w-4 h-4 text-green-500" />
            <div className="flex flex-col items-start gap-0.5 text-left">
              <span className="text-[10px] uppercase tracking-widest text-slate-400 font-bold">WhatsApp Support</span>
              <span className="text-sm font-semibold text-slate-700">+94 76 699 0430</span>
            </div>
          </a>
          
        </div>
      </main>
    </div>
  );
}
